import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { BlueButton, H3, B3 } from '../StyledComponents';
import './Header.scss';
import EsperLogoWhite from '../../assets/v2/esper_light.svg';
import EsperLogoBlue from '../../assets/v2/esper.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import HipchatChevronDownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';
import { navigate } from '@reach/router';
import HealthCareIcon from '../../assets/Header/healthcare_icon.svg';
import RetailIcon from '../../assets/Header/retail_icon.svg';
import DigitalSignageIcon from '../../assets/Header/digital_signage_icon.svg';
import AndroidHardwareIcon from '../../assets/Header/android_hardware_icon.svg';
import AndroidVirtualDeviceIcon from '../../assets/Header/android_virtual_devices_icon.svg';
import AndroidX86Icon from '../../assets/Header/android_x86_icon.svg';
import KioskIcon from '../../assets/Header/kiosk_icon.svg';
import TestAndroidAppIcon from '../../assets/Header/test_android_app_icon.svg';
import { getLanguageFromPath } from '../../helpers';

interface HeaderProps {
  siteTitle?: string;
  location?: any;
  messages?: any;
  switchLanguage?: any;
  currentLanguage?: any;
  siteUrl: string;
}

const BlueButtonWrapper = styled(BlueButton)`
  @media (max-width: 1280px) {
    padding: 0rem 2rem;
  }
  @media (max-width: 980px) {
    padding: 0rem 3rem;
  }
`;
const HeaderTitle = styled(B3)`
  font-weight: 400;
  padding-left: 5px;
  font-size: 14px;
  margin-top: 20px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f2f2f;
  transition: color 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  :hover {
    color: #725cbd;
  }
`;
const HeaderItem = styled.div`
  display: grid;
  padding: 0rem !important;
  background-color: #f9fbfe;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;

const LoginSpan = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 1280px) {
    margin-left: 2rem !important;
  }
  @media (max-width: 1150px) {
    margin-left: 0.25rem !important;
  }
  @media (max-width: 768px) {
    margin-left: 0.25rem !important;
  }
`;

const HeaderDescription = styled(B3)`
  font-size: 12px;
  padding-left: 5px;
  margin-top: 5px;
  color: #4a5275a6;
`;

const SolutionFlex = styled.div`
  display: flex;
  align-items: center;
  height: 42px;
`;

const SolutionCategoryContainer = styled.div`
  margin-bottom: 20px;

  @media (max-width: 990px) {
    margin-top: -1rem;
    margin-left: -1rem;
  }
  @media (max-width: 770px) {
    &:nth-of-type(2) {
      margin-top: 2rem;
      margin-bottom: 0;
    }
  }
`;

const SolutionCategoryTitle = styled(B3)`
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f2f2f;
`;
const SolutionHeaderTitle = styled(B3)`
  height: 30px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  padding-left: 7px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f2f2f;
`;

const CustomerStories = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: 300;
  align-self: center;
  font-style: normal;
  margin-left: -20px;
  justify-self: left;
  text-align: left;
  margin-top: 8px;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;

  @media (max-width: 1600px) {
    display: none;
  }
  @media (max-width: 900px) {
    display: unset;
  }
  @media (max-width: 400px) {
    display: none;
  }
`;
interface HeaderState {
  sticky: boolean;
  drawerOpen: boolean;
  expandItemMobile: string;
  languageDropdown: boolean;
  isPageLight: boolean;
  languageDropdownEnabled: boolean;
  isPageExternal: boolean;
  currentPage: string;
  currentLanguageURL: string;
}
class Header extends React.Component<HeaderProps, HeaderState> {
  constructor(props: HeaderProps) {
    super(props);
    this.state = {
      sticky: false,
      drawerOpen: false,
      expandItemMobile: '',
      languageDropdown: false,
      isPageLight: !this.checkIfPageDark(),
      languageDropdownEnabled: this.checkifLanguageDropdownEnabled(),
      isPageExternal: this.checkIfPageIsExternal(),
      currentPage: getLanguageFromPath(this.props.siteUrl)
        ? this.props.siteUrl?.split('/')[2]
        : this.props.siteUrl?.split('/')[1],
      currentLanguageURL: getLanguageFromPath(this.props.siteUrl)
        ? `/${getLanguageFromPath(this.props.siteUrl)}`
        : '',
    };
  }
  componentDidMount() {
    const navbar = document.getElementById('navbar-main');
    if (navbar) {
      const sticky = navbar.offsetTop + 1;
      document.onscroll = () => this.myFunction(sticky);
    }
  }

  checkIfPageIsExternal = () => {
    if (this.props.siteUrl?.includes('customer-stories')) {
      return true;
    }
    return false;
  };

  checkIfPageDark = () => {
    if (getLanguageFromPath(this.props.siteUrl)) {
      const pathPart2 = this.props.siteUrl?.split('/')[2];
      if (
        pathPart2 === 'terms-of-service' ||
        pathPart2 === 'developer' ||
        pathPart2 === 'privacy-policy' ||
        pathPart2 === 'test-lab' ||
        pathPart2 === 'wishlist' ||
        pathPart2 === 'platform' ||
        pathPart2 === 'android-virtual-device' ||
        pathPart2 === 'developer-tools' ||
        // pathPart2 === 'hardware' ||
        pathPart2 === 'media-coverage' ||
        pathPart2 === 'custom-device' ||
        pathPart2 === 'submitted' ||
        this.props.siteUrl?.split('/')[3] === 'submitted' ||
        pathPart2 === '' ||
        // pathPart2 === 'odroid-n2' ||
        pathPart2 === 'kiosk-device-management' ||
        pathPart2 === 'retail-device-management' ||
        pathPart2 === 'thankyou' ||
        pathPart2 === 'android-x86' ||
        // pathPart2 === 'signup' ||
        pathPart2 === 'thankyou' ||
        pathPart2 === 'android-device-management'
      ) {
        return true;
      }
      return false;
    }
    const pathPart1 = this.props.siteUrl?.split('/')[1];
    if (
      pathPart1 === 'terms-of-service' ||
      pathPart1 === 'developer' ||
      pathPart1 === 'privacy-policy' ||
      pathPart1 === 'test-lab' ||
      pathPart1 === 'wishlist' ||
      pathPart1 === 'platform' ||
      pathPart1 === 'android-virtual-device' ||
      pathPart1 === 'developer-tools' ||
      pathPart1 === 'media-coverage' ||
      pathPart1 === 'custom-device' ||
      this.props.siteUrl?.split('/')[2] === 'submitted' ||
      this.props.siteUrl?.split('/')[3] === 'submitted' ||
      pathPart1 === 'submitted' ||
      pathPart1 === '' ||
      pathPart1 === 'kiosk-device-management' ||
      pathPart1 === 'retail-device-management' ||
      pathPart1 === 'thankyou' ||
      pathPart1 === 'android-x86' ||
      this.props.siteUrl?.split('/')[2] === 'thankyou' ||
      this.props.siteUrl?.split('/')[2] === 'android-device-management'
    ) {
      return true;
    }
    return false;
  };

  languageDropdownEnable = () => {
    this.setState({ languageDropdown: !this.state.languageDropdown });
  };

  myFunction = (sticky: any) => {
    if (window.pageYOffset > sticky) {
      this.setState({ sticky: true });
    } else {
      this.setState({ sticky: false });
    }
  };

  getCurrentLanguage = (langKey: string) => {
    switch (langKey) {
      case 'es':
        return 'Spanish';
      case 'en':
        return 'English';
      case 'de':
        return 'Deutsch';
      default:
        return 'English';
    }
  };

  checkifLanguageDropdownEnabled = () => {
    if (
      this.props.siteUrl?.includes('signup') ||
      this.props.siteUrl?.includes('login') ||
      this.props.siteUrl?.includes('contact-us') ||
      this.props.siteUrl?.includes('aboutus') ||
      this.props.siteUrl?.includes('pricing') ||
      this.props.siteUrl?.includes('faq') ||
      this.props.siteUrl?.includes('terms-of-service') ||
      this.props.siteUrl?.includes('privacy-policy') ||
      this.props.siteUrl?.includes('book-demo') ||
      this.props.siteUrl?.includes('submitted') ||
      this.props.siteUrl?.split('/')[1] === '' ||
      (this.props.siteUrl?.split('/')[1] === 'de' &&
        this.props.siteUrl?.split('/')[2] === '') ||
      (this.props.siteUrl?.split('/')[1] === 'es' &&
        this.props.siteUrl?.split('/')[2] === '')
    ) {
      return true;
    }
    return false;
  };

  public render() {
    return (
      <header>
        <nav
          id="navbar-main"
          className={`navbar navbar-main navbar-expand-lg navbar-transparent ${
            (this.state.isPageLight ||
              (this.state.sticky && !this.state.drawerOpen)) &&
            !this.state.isPageExternal
              ? `navbar-light navbar-sticky`
              : `navbar-dark`
          }`}
          style={
            this.state.isPageExternal
              ? { backgroundColor: '#1b2341' }
              : this.state.sticky
              ? {
                  position: 'fixed',
                  backgroundColor: '#ffffff',
                  height: '10%',
                  transition:
                    'height 0.25s ease-in-out, background-color 0.25s ease-in-out',
                  boxShadow: '0 4px 9px 0 rgba(72,82,108,0.15)',
                }
              : {
                  transition:
                    'height 0.25s ease-in-out, background-color 0.s ease-in-out',
                  // height: '12%',
                }
          }
        >
          <div
            className="container header"
            style={{ paddingLeft: '0px', paddingRight: '0px' }}
          >
            <Link
              className="navbar-brand mr-lg-2"
              aria-label="Esper Logo"
              title="Esper Logo"
              to={`${this.state.currentLanguageURL}/`}
            >
              {this.state.drawerOpen ? undefined : (this.state.isPageLight ||
                  this.state.sticky) &&
                !this.state.isPageExternal ? (
                <LazyLoadImage
                  src={EsperLogoBlue}
                  alt="Esper logo"
                  id="navbar-main-logo"
                  style={{
                    height: '44px',
                    width: '180px',
                    marginLeft: '-26px',
                    transition: '1s ease-in-out',
                  }}
                />
              ) : (
                <LazyLoadImage
                  src={EsperLogoWhite}
                  alt="Esper logo"
                  id="navbar-main-logo"
                  style={{
                    height: '44px',
                    width: '180px',
                    marginLeft: '-26px',
                    transition: '1s ease-in-out',
                  }}
                />
              )}
            </Link>

            {this.state.languageDropdownEnabled && (
              <div
                className=""
                onClick={this.languageDropdownEnable}
                style={{
                  cursor: 'pointer',
                  position: 'relative',
                  display: 'inline-block',
                  fontSize: '15px',
                  color:
                    (this.state.isPageLight ||
                      (this.state.sticky && !this.state.drawerOpen)) &&
                    !this.state.isPageExternal
                      ? '#2f2f2f'
                      : '#ffffff',
                }}
              >
                <span className="nav-link-inner--text">
                  {this.getCurrentLanguage(this.props.currentLanguage)}

                  <span
                    style={{
                      position: 'absolute',
                      right: '-2rem',
                      top: this.state.languageDropdown ? '-0.3rem' : 'unset',
                    }}
                    className={
                      this.state.languageDropdown ? 'rotate' : 'reverse'
                    }
                  >
                    <HipchatChevronDownIcon label="down" />
                  </span>
                </span>
                <div
                  style={{
                    display: this.state.languageDropdown ? 'block' : 'none',
                    position: 'absolute',
                    backgroundColor: 'rgb(255 255 255)',
                    minWidth: '160px',
                    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 3px 10px 0px',
                    padding: '12px 16px',
                    zIndex: 1,
                    marginTop: '15px',
                  }}
                >
                  <HeaderTitle
                    style={{ marginTop: '0', padding: '10px' }}
                    onClick={() => this.props.switchLanguage()}
                  >
                    English
                  </HeaderTitle>
                  <HeaderTitle
                    style={{ marginTop: '0', padding: '10px' }}
                    onClick={() => this.props.switchLanguage('de')}
                  >
                    Deutsch
                  </HeaderTitle>
                  {!this.props.siteUrl?.includes('aboutus') && (
                    <HeaderTitle
                      style={{ marginTop: '0', padding: '10px' }}
                      onClick={() => this.props.switchLanguage('es')}
                    >
                      Spanish
                    </HeaderTitle>
                  )}
                </div>
              </div>
            )}

            {this.state.isPageExternal && (
              <CustomerStories>/ Customer Stories</CustomerStories>
            )}
            <button
              className={`navbar-toggler ${
                this.state.drawerOpen ? '' : 'collapsed'
              }`}
              type="button"
              data-toggle="collapse"
              data-target="#navbar_global"
              onClick={() => this.setState({ drawerOpen: true })}
              aria-controls="navbar_global"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div
              className={`navbar-collapse collapse ${
                this.state.drawerOpen ? 'show ' : ''
              }`}
              id="navbar_global"
            >
              <div className="navbar-collapse-header">
                <div className="row">
                  <div className="col-6 collapse-brand">
                    <Link
                      aria-label="Esper Logo"
                      title="Esper Logo"
                      to={`${this.state.currentLanguageURL}/`}
                    >
                      <LazyLoadImage
                        src={EsperLogoBlue}
                        id="navbar-main-logo"
                        alt="Esper logo"
                        style={{
                          height: '44px',
                          width: '180px',
                          marginLeft: '-26px',
                          transition: '1s ease-in-out',
                        }}
                      />
                    </Link>
                  </div>
                  <div className="col-6 collapse-close">
                    <button
                      type="button"
                      onClick={() => this.setState({ drawerOpen: false })}
                      className="navbar-toggler"
                      data-toggle="collapse"
                      data-target="#navbar_global"
                      aria-controls="navbar_global"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <span />
                      <span />
                    </button>
                  </div>
                </div>
              </div>
              <ul className="navbar-nav navbar-nav-hover align-items-lg-center" />
              <ul className="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto">
                {/* <li className="nav-item">
                  <Link
                    className="nav-link "
                    to="/platform"
                    rel="preload"
                    data-toggle="tooltip"
                    title="Platform"
                  >
                    <span
                      style={
                        this.state.currentPage === 'platform'
                          ? { fontFamily: `Nunito Sans`, fontWeight: 'bold' }
                          : { fontFamily: `Nunito Sans` }
                      }
                      className="nav-link-inner--text"
                    >
                      Platform
                    </span>
                  </Link>
                </li> */}
                {(!this.props.messages ||
                  this.props.messages?.locale === 'en') && (
                  <>
                    <li className="nav-item">
                      <Link
                        className="nav-link "
                        to={'/developer'}
                        rel="preload"
                        id="navbar-main-developer"
                        data-toggle="tooltip"
                        title="App Management"
                      >
                        <span
                          style={
                            this.state.currentPage === 'developer'
                              ? {
                                  fontFamily: `Nunito Sans`,
                                  fontWeight: 'bold',
                                }
                              : { fontFamily: `Nunito Sans` }
                          }
                          className="nav-link-inner--text"
                          id="navbar-main-developer-text"
                        >
                          Developer Tools
                        </span>
                      </Link>
                    </li>
                    <li
                      className={`nav-item dropdown ${
                        this.state.expandItemMobile === 'solutions'
                          ? 'show'
                          : ''
                      }`}
                    >
                      <a
                        // href="#"
                        className="nav-link "
                        data-toggle="dropdown"
                        role="button"
                        title="Esper Solutions"
                        id="navbar-main-solutions"
                      >
                        <div
                          style={{
                            display: 'flex',
                            cursor: 'pointer',
                            position: 'relative',
                          }}
                          onClick={() =>
                            this.setState((state: any) => ({
                              expandItemMobile:
                                state.expandItemMobile === 'solutions'
                                  ? ''
                                  : 'solutions',
                            }))
                          }
                        >
                          <span
                            style={{ fontFamily: `Nunito Sans` }}
                            className="nav-link-inner--text"
                            // onClick={() =>
                            //   this.setState((state: any) => ({
                            //     expandItemMobile:
                            //       state.expandItemMobile === 'solutions'
                            //         ? ''
                            //         : 'solutions',
                            //   }))
                            // }
                            id="navbar-main-solutions-text"
                          >
                            Solutions
                          </span>
                          {this.state.drawerOpen && (
                            <div
                              style={{ position: 'absolute', right: '2rem' }}
                              className={
                                this.state.expandItemMobile !== 'solutions'
                                  ? 'reverse'
                                  : 'rotate'
                              }
                            >
                              <HipchatChevronDownIcon label="down" />
                            </div>
                          )}
                        </div>
                      </a>
                      <div
                        className={`dropdown-menu dropdown-menu-xl ${
                          this.state.expandItemMobile === 'solutions'
                            ? 'show'
                            : ''
                        }`}
                        style={{ padding: '0rem' }}
                      >
                        {' '}
                        <HeaderItem className="dropdown-menu-inner">
                          <div className="media d-flex">
                            <div className="media-body">
                              <SolutionCategoryContainer>
                                <SolutionCategoryTitle>
                                  Industry
                                </SolutionCategoryTitle>
                                <Link
                                  to="/healthcare"
                                  id="navbar-main-solutions-healthcare"
                                >
                                  <SolutionFlex>
                                    <LazyLoadImage
                                      src={HealthCareIcon}
                                      id="navbar-solution-healthcare-icon"
                                      alt="HealthCare Icon"
                                      style={{
                                        height: '30px',
                                        width: '30px',
                                        objectFit: 'contain',
                                      }}
                                    />
                                    <SolutionHeaderTitle id="navbar-main-solutions-healthcare-text">
                                      Healthcare
                                    </SolutionHeaderTitle>
                                  </SolutionFlex>
                                </Link>
                                <Link
                                  to="/retail-device-management"
                                  id="navbar-main-solutions-retail"
                                >
                                  <SolutionFlex>
                                    <LazyLoadImage
                                      src={RetailIcon}
                                      id="navbar-solution-retail-icon"
                                      alt="Retail Icon"
                                      style={{
                                        height: '30px',
                                        width: '30px',
                                        objectFit: 'contain',
                                      }}
                                    />
                                    <SolutionHeaderTitle id="navbar-main-solutions-retail-text">
                                      Retail
                                    </SolutionHeaderTitle>
                                  </SolutionFlex>
                                </Link>
                              </SolutionCategoryContainer>
                              <SolutionCategoryContainer>
                                <SolutionCategoryTitle>
                                  Device type
                                </SolutionCategoryTitle>
                                <Link
                                  to="/digital-signage"
                                  id="navbar-main-solutions-digital-signage"
                                >
                                  <SolutionFlex>
                                    <LazyLoadImage
                                      src={DigitalSignageIcon}
                                      id="navbar-solution-digital-signage-icon"
                                      alt="Digital Signage Icon"
                                      style={{
                                        height: '30px',
                                        width: '30px',
                                        objectFit: 'contain',
                                      }}
                                    />
                                    <SolutionHeaderTitle id="navbar-main-solutions-digital-text">
                                      Digital Signage
                                    </SolutionHeaderTitle>
                                  </SolutionFlex>
                                </Link>
                                <Link
                                  to="/kiosk-device-management"
                                  id="navbar-main-solutions-kiosk"
                                >
                                  <SolutionFlex>
                                    <LazyLoadImage
                                      src={KioskIcon}
                                      id="navbar-solution-kiosk-icon"
                                      alt="Kiosk Icon"
                                      style={{
                                        height: '30px',
                                        width: '30px',
                                        objectFit: 'contain',
                                      }}
                                    />
                                    <SolutionHeaderTitle id="navbar-main-solutions-kiosk-text">
                                      Kiosk
                                    </SolutionHeaderTitle>
                                  </SolutionFlex>
                                </Link>
                                <Link
                                  to="/custom-device"
                                  id="navbar-main-solutions-custom-device"
                                >
                                  <SolutionFlex>
                                    <LazyLoadImage
                                      src={AndroidHardwareIcon}
                                      id="navbar-solution-custom-android-hardware-icon"
                                      alt="Custom Android Hardware Icon"
                                      style={{
                                        height: '30px',
                                        width: '30px',
                                        objectFit: 'contain',
                                      }}
                                    />
                                    <SolutionHeaderTitle id="navbar-main-solutions-custom-device-text">
                                      Custom Android Hardware
                                    </SolutionHeaderTitle>
                                  </SolutionFlex>
                                </Link>
                              </SolutionCategoryContainer>
                            </div>
                          </div>
                          <div className="media d-flex">
                            <div className="media-body">
                              {/* <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '3rem auto',
                            }}
                          >
                            <div className="icon icon-shape rounded-circle text-white">
                              <LazyLoadImage
                                alt="Enterprise"
                                src={Enterprise}
                              />
                            </div>
                            <H3
                              style={{
                                alignSelf: 'center',
                                justifySelf: 'start',
                                fontWeight: 'bold',
                              }}
                              className="heading text-primary mb-md-1"
                            >
                              Manage
                            </H3>
                          </div> */}
                              <SolutionCategoryContainer>
                                <SolutionCategoryTitle>
                                  Esper Dev Tools
                                </SolutionCategoryTitle>
                                <Link
                                  to="/android-virtual-device"
                                  id="navbar-main-solutions-android-virtual-devices"
                                >
                                  <SolutionFlex>
                                    <LazyLoadImage
                                      src={AndroidVirtualDeviceIcon}
                                      id="navbar-solution-android-virtual-device-icon"
                                      alt="Android Virtual Device Icon"
                                      style={{
                                        height: '30px',
                                        width: '30px',
                                        objectFit: 'contain',
                                      }}
                                    />
                                    <SolutionHeaderTitle id="navbar-main-solutions-android-virtual-devices-text">
                                      Android Virtual Device
                                    </SolutionHeaderTitle>
                                  </SolutionFlex>
                                </Link>
                                <Link
                                  to="/android-x86"
                                  id="navbar-main-solutions-x86"
                                >
                                  <SolutionFlex>
                                    <LazyLoadImage
                                      src={AndroidX86Icon}
                                      id="navbar-solution-android-x86-icon"
                                      alt="Android x86 Icon"
                                      style={{
                                        height: '30px',
                                        width: '30px',
                                        objectFit: 'contain',
                                      }}
                                    />
                                    <SolutionHeaderTitle id="navbar-main-solutions-x86-text">
                                      Android x86
                                    </SolutionHeaderTitle>
                                  </SolutionFlex>
                                </Link>
                                <Link
                                  to="/test-lab"
                                  id="navbar-main-solutions-test-lab"
                                >
                                  <SolutionFlex>
                                    <LazyLoadImage
                                      src={TestAndroidAppIcon}
                                      id="navbar-solution-test-android-applications-icon"
                                      alt="Test Android Applications Icon"
                                      style={{
                                        height: '30px',
                                        width: '30px',
                                        objectFit: 'contain',
                                      }}
                                    />
                                    <SolutionHeaderTitle id="navbar-main-solutions-test-lab-text">
                                      Test Android Applications
                                    </SolutionHeaderTitle>
                                  </SolutionFlex>
                                </Link>
                              </SolutionCategoryContainer>
                            </div>
                          </div>
                        </HeaderItem>
                      </div>
                    </li>
                    {/* <li
                  className={`nav-item dropdown ${
                    this.state.expandItemMobile === 'hardware' ? 'show' : ''
                  }`}
                >
                  <a
                    href="#"
                    className="nav-link "
                    data-toggle="dropdown"
                    role="button"
                    title="Hardware"
                    id="navbar-main-hardware"
                  >
                    <div
                      style={{
                        display: 'flex',
                        cursor: 'pointer',
                        position: 'relative',
                      }}
                      onClick={() =>
                        this.setState((state: any) => ({
                          expandItemMobile:
                            state.expandItemMobile === 'hardware'
                              ? ''
                              : 'hardware',
                        }))
                      }
                    >
                      <span
                        style={{ fontFamily: `Nunito Sans` }}
                        className="nav-link-inner--text"
                        // onClick={() =>
                        //   this.setState((state: any) => ({
                        //     expandItemMobile:
                        //       state.expandItemMobile === 'hardware'
                        //         ? ''
                        //         : 'hardware',
                        //   }))
                        // }
                        id="navbar-main-hardware-text"
                      >
                        Hardware
                      </span>
                      {this.state.drawerOpen && (
                        <div
                          style={{ position: 'absolute', right: '2rem' }}
                          className={
                            this.state.expandItemMobile !== 'hardware'
                              ? 'reverse'
                              : 'rotate'
                          }
                        >
                          <HipchatChevronDownIcon label="down" />
                        </div>
                      )}
                    </div>
                  </a>
                  <div
                    className={`dropdown-menu dropdown-menu-l ${
                      this.state.expandItemMobile === 'hardware' ? 'show' : ''
                    }`}
                    style={{ padding: '0rem' }}
                  >
                    {' '}
                    <HeaderItem
                      style={{ gridTemplateColumns: 'auto' }}
                      className="dropdown-menu-inner"
                    >
                      <div className="media d-flex">
                        <div className="media-body">
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '3rem auto',
                              cursor: 'pointer',
                            }}
                            onClick={() => navigate('/hardware')}
                          >
                            <div className="icon icon-shape rounded-circle text-white">
                              <LazyLoadImage
                                alt="Enterprise"
                                height="33px"
                                src={Commercial}
                              />
                            </div>

                            <div>
                              <H3
                                style={{
                                  alignSelf: 'center',
                                  justifySelf: 'start',
                                  fontWeight: 'bold',
                                  marginLeft: '5px',
                                }}
                                className="heading text-primary mb-md-1"
                                id="navbar-main-hardware-commercial-android"
                              >
                                Commercial Android
                              </H3>

                              <HeaderDescription
                                style={{
                                  marginBottom: '2rem',
                                }}
                                id="navbar-main-hardware-commercial-android-desc"
                              >
                                Pick the right Android device for your
                                application.
                              </HeaderDescription>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '3rem auto',
                              cursor: 'pointer',
                            }}
                            onClick={() => navigate('/wishlist')}
                          >
                            <div className="icon icon-shape rounded-circle text-white">
                              <LazyLoadImage
                                alt="Enterprise"
                                src={Heart}
                                height="33px"
                              />
                            </div>
                            <div>
                              <H3
                                style={{
                                  alignSelf: 'center',
                                  justifySelf: 'start',
                                  fontWeight: 'bold',
                                  marginLeft: '5px',
                                }}
                                className="heading text-primary mb-md-1"
                                id="navbar-main-wishlist"
                              >
                                Wishlist
                              </H3>

                              <HeaderDescription id="navbar-main-wishlist-desc">
                                Learn more about the products in your Wishlist,
                                compare, test and make a learned decision.
                              </HeaderDescription>
                            </div>
                          </div>
                        </div>
                      </div>
                    </HeaderItem>
                  </div>
                </li> */}
                    <li className="nav-item">
                      <Link
                        className="nav-link "
                        to={`/hardware`}
                        rel="preload"
                        data-toggle="tooltip"
                        title="Hardware"
                        id="navbar-main-pricing"
                      >
                        <span
                          style={
                            this.state.currentPage === 'hardware'
                              ? {
                                  fontFamily: `Nunito Sans`,
                                  fontWeight: 'bold',
                                }
                              : { fontFamily: `Nunito Sans` }
                          }
                          className="nav-link-inner--text"
                          id="navbar-main-pricing-text"
                        >
                          Hardware
                        </span>
                      </Link>
                    </li>

                    {/* <li className="nav-item">
                  <Link
                    className="nav-link "
                    to={`/hardware`}
                    rel="preload"
                    id="navbar-main-hardware"
                    data-toggle="tooltip"
                    title="Pricing"
                  >
                    <span
                      style={
                        this.state.currentPage === 'hardware'
                          ? { fontFamily: `Nunito Sans`, fontWeight: 'bold' }
                          : { fontFamily: `Nunito Sans` }
                      }
                      className="nav-link-inner--text"
                    >
                      Hardware
                    </span>
                  </Link>
                </li> */}
                  </>
                )}
                <li className="nav-item">
                  <Link
                    className="nav-link "
                    to={`${this.state.currentLanguageURL}/pricing`}
                    rel="preload"
                    data-toggle="tooltip"
                    title={
                      this.props.messages?.WebsiteGeneralMenuPricing ??
                      'Pricing'
                    }
                    id="navbar-main-pricing-2"
                  >
                    <span
                      style={
                        this.state.currentPage === 'pricing'
                          ? { fontFamily: `Nunito Sans`, fontWeight: 'bold' }
                          : { fontFamily: `Nunito Sans` }
                      }
                      className="nav-link-inner--text"
                      id="navbar-main-pricing-2-text"
                    >
                      {this.props.messages?.WebsiteGeneralMenuPricing ??
                        'Pricing'}
                    </span>
                  </Link>
                </li>
                <li
                  className={`nav-item dropdown ${
                    this.state.expandItemMobile === 'why-esper' ? 'show' : ''
                  }`}
                >
                  <a
                    // href="#"
                    className="nav-link "
                    data-toggle="dropdown"
                    role="button"
                    id="navbar-main-why-esper"
                    title={
                      this.props.messages?.WebsiteGeneralMenuWhyEsper ??
                      'Why Esper?'
                    }
                  >
                    <div
                      style={{
                        display: 'flex',
                        cursor: 'pointer',
                        position: 'relative',
                      }}
                      onClick={() =>
                        this.setState((state: any) => ({
                          expandItemMobile:
                            state.expandItemMobile === 'why-esper'
                              ? ''
                              : 'why-esper',
                        }))
                      }
                    >
                      <span
                        style={{ fontFamily: `Nunito Sans` }}
                        className="nav-link-inner--text"
                        onClick={() =>
                          this.setState((state: any) => ({
                            expandItemMobile:
                              state.expandItemMobile === 'why-esper'
                                ? ''
                                : 'why-esper',
                          }))
                        }
                        id="navbar-main-why-esper-text"
                      >
                        {this.props.messages?.WebsiteGeneralMenuWhyEsper ??
                          'Why Esper?'}
                      </span>
                      {this.state.drawerOpen && (
                        <div
                          style={{ position: 'absolute', right: '2rem' }}
                          className={
                            this.state.expandItemMobile !== 'why-esper'
                              ? 'reverse'
                              : 'rotate'
                          }
                        >
                          <HipchatChevronDownIcon label="down" />
                        </div>
                      )}
                    </div>
                  </a>
                  <div
                    className={`dropdown-menu dropdown-menu-l ${
                      this.state.expandItemMobile === 'why-esper' ? 'show' : ''
                    }`}
                    style={{ padding: '0rem' }}
                  >
                    {' '}
                    <HeaderItem className="dropdown-menu-inner">
                      <div className="media d-flex">
                        <div className="media-body">
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '3rem auto',
                            }}
                          >
                            <H3
                              style={{
                                alignSelf: 'center',
                                justifySelf: 'start',
                                fontWeight: 'bold',
                              }}
                              className="heading text-primary mb-md-1"
                            >
                              {this.props.messages
                                ?.WebsiteGeneralMenuResources ?? 'Resources'}
                            </H3>
                          </div>
                          <div style={{ marginBottom: '20px' }}>
                            <a
                              href="https://docs.esper.io"
                              id="navbar-main-why-esper-docs"
                            >
                              <HeaderTitle id="navbar-main-why-esper-docs-text">
                                {this.props.messages
                                  ?.WebsiteGeneralFooterDocs ?? 'Docs'}
                              </HeaderTitle>
                              {/* <HeaderDescription>
                                Build Custom Android Virtual Devices
                              </HeaderDescription> */}
                            </a>
                            <a
                              href="https://blog.esper.io"
                              id="navbar-main-why-esper-blog"
                            >
                              <HeaderTitle id="navbar-main-why-esper-blog-text">
                                {this.props.messages
                                  ?.WebsiteGeneralFooterBlog ?? 'Blog'}
                              </HeaderTitle>
                              {/* <HeaderDescription>
                                Test Android applications on real devices
                              </HeaderDescription> */}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="media d-flex">
                        <div className="media-body">
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '3rem auto',
                            }}
                          >
                            <H3
                              style={{
                                alignSelf: 'center',
                                justifySelf: 'start',
                                fontWeight: 'bold',
                              }}
                              className="heading text-primary mb-md-1"
                            >
                              {this.props.messages?.WebsiteGeneralMenuCompany ??
                                'Company'}
                            </H3>
                          </div>
                          <div style={{ marginBottom: '20px' }}>
                            {this.props.currentLanguage !== 'es' && (
                              <Link
                                to={`${this.state.currentLanguageURL}/aboutus`}
                                id="navbar-main-why-esper-about-us"
                              >
                                <HeaderTitle id="navbar-main-why-esper-about-us-text">
                                  {this.props.messages
                                    ?.WebsiteGeneralMenuAboutUs ?? 'About Us'}
                                </HeaderTitle>
                                {/* <HeaderDescription>
                                The First Full-Stack Software Solution for the
                                Kiosk Industry
                              </HeaderDescription> */}
                              </Link>
                            )}
                            {(!this.props.messages ||
                              this.props.messages?.locale === 'en') && (
                              <>
                                <Link to="/partner" id="navbar-main-partner">
                                  <HeaderTitle id="navbar-main-partner-text">
                                    Partner
                                  </HeaderTitle>
                                  {/* <HeaderDescription>
                                The First Full-Stack Software Solution for the
                                Kiosk Industry
                              </HeaderDescription> */}
                                </Link>
                                <Link
                                  to="/media-coverage"
                                  id="navbar-main-why-esper-media-coverage"
                                >
                                  <HeaderTitle id="navbar-main-why-esper-media-coverage-text">
                                    Media Coverage
                                  </HeaderTitle>
                                  {/* <HeaderDescription>
                                The First Full-Stack Software Solution for the
                                Kiosk Industry
                              </HeaderDescription> */}
                                </Link>
                                <Link
                                  to="/careers"
                                  id="navbar-main-why-esper-careers"
                                >
                                  <HeaderTitle id="navbar-main-why-esper-careers-text">
                                    Careers
                                  </HeaderTitle>
                                  {/* <HeaderDescription>
                                Bring Android to your x86 Device with Esper.
                              </HeaderDescription> */}
                                </Link>
                              </>
                            )}
                            <Link
                              to={`${this.state.currentLanguageURL}/contact-us`}
                              id="navbar-main-why-esper-contact-us"
                            >
                              <HeaderTitle id="navbar-main-why-esper-contact-us-text">
                                {this.props.messages
                                  ?.WebsiteGeneralMenuContactUs ?? 'Contact Us'}
                              </HeaderTitle>
                              {/* <HeaderDescription>
                                Bring Android to your x86 Device with Esper.
                              </HeaderDescription> */}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </HeaderItem>
                  </div>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link "
                    to={`${this.state.currentLanguageURL}/book-demo`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-toggle="tooltip"
                    title={
                      this.props.messages?.WebsiteGeneralFooterBookDemo ??
                      'Book Demo'
                    }
                    id="navbar-main-book-demo-top-button"
                  >
                    <span
                      style={
                        this.state.currentPage === 'book-demo'
                          ? { fontFamily: `Nunito Sans`, fontWeight: 'bold' }
                          : { fontFamily: `Nunito Sans` }
                      }
                      className="nav-link-inner--text"
                      id="navbar-main-book-demo-top-button-text"
                    >
                      {this.props.messages?.WebsiteGeneralFooterBookDemo ??
                        'Book Demo'}
                    </span>
                  </Link>
                </li>
                {/* <li className="nav-item">
                  <a
                    className="nav-link "
                    href="https://docs.esper.io"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-toggle="tooltip"
                    title="Esper Docs"
                  >
                    <span
                      style={{ fontFamily: `Nunito Sans` }}
                      className="nav-link-inner--text"
                    >
                      Docs
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link "
                    href="/aboutus"
                    data-toggle="tooltip"
                    title="About us"
                  >
                    <span
                      style={{ fontFamily: `Nunito Sans` }}
                      className="nav-link-inner--text"
                    >
                      About us
                    </span>
                  </a>
                </li> */}
                {/*
                <li className="nav-item">
                  <a
                    className="nav-link "
                    href="/android-x86"
                    data-toggle="tooltip"
                    title="Android x86"
                  >
                    <span
                      style={{ fontFamily: `Nunito Sans` }}
                      className="nav-link-inner--text"
                    >
                      Android x86
                    </span>
                  </a>
                </li> */}

                <li className="nav-item">
                  <Link
                    className="nav-link "
                    to={`${this.state.currentLanguageURL}/login`}
                    data-toggle="tooltip"
                    title={
                      this.props.messages?.WebsiteGeneralLoginCTA ?? 'Login'
                    }
                  >
                    <LoginSpan
                      id="navbar-main-login-top-button"
                      className="nav-link-inner--text"
                    >
                      {this.props.messages?.WebsiteGeneralLoginCTA ?? 'Login'}
                    </LoginSpan>
                  </Link>
                </li>
                <li className="nav-item d-none d-lg-block ml-lg-2">
                  <BlueButtonWrapper
                    onClick={() => {
                      navigate(`${this.state.currentLanguageURL}/signup`);
                    }}
                    id="navbar-main-signup-top-button"
                    style={{ fontWeight: 'bold', letterSpacing: '0.5px' }}
                  >
                    {this.props.messages?.WebsiteGeneralSignupCTA ?? 'Sign up'}
                  </BlueButtonWrapper>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
    );
  }
}

export default Header;
